import { render, staticRenderFns } from "./OfficialOrg.vue?vue&type=template&id=bf910f02&scoped=true"
import script from "./OfficialOrg.vue?vue&type=script&lang=js"
export * from "./OfficialOrg.vue?vue&type=script&lang=js"
import style0 from "./OfficialOrg.vue?vue&type=style&index=0&id=bf910f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf910f02",
  null
  
)

export default component.exports